// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

/**
 * Helper to append the current 'lang' query parameter to any outgoing location.
 */
function appendLangParam(location) {
  // Extract current lang from the browser's URL
  const currentParams = new URLSearchParams(window.location.search);
  const lang = currentParams.get('lang');

  // If no lang is present in the current URL, just return the location unchanged
  if (!lang) return location;

  // Handle string locations (e.g., history.push('/about'))
  if (typeof location === 'string') {
    const url = new URL(location, window.location.origin);
    if (!url.searchParams.has('lang')) {
      url.searchParams.set('lang', lang);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }

  // Handle object locations (e.g., history.push({ pathname: '/about', search: '?foo=bar' }))
  if (typeof location === 'object' && location !== null) {
    const newLocation = { ...location };
    const searchParams = new URLSearchParams(newLocation.search || '');
    if (!searchParams.has('lang')) {
      searchParams.set('lang', lang);
      newLocation.search = `?${searchParams.toString()}`;
    }
    return newLocation;
  }

  return location;
}

const originalPush = history.push;
const originalReplace = history.replace;
const originalCreateHref = history.createHref;

// Override history methods to intercept all navigations
history.push = (path, state) => originalPush(appendLangParam(path), state);
history.replace = (path, state) => originalReplace(appendLangParam(path), state);
history.createHref = (location) => originalCreateHref(appendLangParam(location));

export default history;
